module.exports = __webpack_public_path__ + "assets/img/benefit-referral.c35a809d.png";